import * as React from "react";

import type { DesignaliProps } from "../../types";

export const AiBeautify = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M13.28,12.92l2.43-2.43c.3-.3.45-.45.53-.61.15-.31.15-.67,0-.98-.08-.16-.23-.31-.53-.61-.3-.3-.45-.45-.61-.53-.31-.15-.67-.15-.98,0-.16.08-.31.23-.61.53l-2.43,2.43M13.28,12.92l-8.43,8.43c-.3.3-.45.45-.61.53-.31.15-.67.15-.98,0-.16-.08-.31-.23-.61-.53-.3-.3-.45-.45-.53-.61-.15-.31-.15-.67,0-.98.08-.16.23-.31.53-.61l8.43-8.43M13.28,12.92l-2.2-2.2" />
        <path d="M9.05,5.67c-.04-.15-.16-.27-.31-.31l-1.34-.34c-.06-.02-.09-.08-.08-.13.01-.04.04-.06.08-.08l1.34-.35c.15-.04.27-.16.31-.31l.34-1.34c.02-.06.08-.09.13-.08.04.01.07.04.08.08l.34,1.34c.04.15.16.27.31.31l1.34.34c.06.02.09.08.08.13-.01.04-.04.07-.08.08l-1.34.34c-.15.04-.27.16-.31.31l-.34,1.34c-.02.06-.08.09-.13.08-.04-.01-.07-.04-.08-.08l-.34-1.34Z" />
        <path d="M18.93,5.43c-.05-.18-.19-.32-.37-.37l-1.56-.4c-.07-.02-.11-.09-.09-.16.01-.04.05-.08.09-.09l1.56-.4c.18-.05.32-.19.37-.37l.4-1.56c.02-.07.09-.11.16-.09.04.01.08.05.09.09l.4,1.56c.05.18.19.32.37.37l1.56.4c.07.02.11.09.09.16-.01.04-.05.08-.09.09l-1.56.4c-.18.05-.32.19-.37.37l-.4,1.56c-.02.07-.09.11-.16.09-.04-.01-.08-.05-.09-.09l-.4-1.56Z" />
        <path d="M18.6,15.48c-.03-.13-.14-.24-.27-.27l-1.17-.3c-.05-.01-.08-.07-.07-.12,0-.03.03-.06.07-.07l1.17-.3c.13-.03.24-.14.27-.27l.3-1.17c.01-.05.07-.08.12-.07.03,0,.06.03.07.07l.3,1.17c.03.13.14.24.27.27l1.17.3c.05.01.08.07.07.12,0,.03-.03.06-.07.07l-1.17.3c-.13.03-.24.14-.27.27l-.3,1.17c-.01.05-.07.08-.12.07-.03,0-.06-.03-.07-.07l-.3-1.17Z" />
      </svg>
    );
  },
);

export default AiBeautify;
